import Vue from 'vue'

export default {
    postContacto(parametros){
        return Vue.axios.post("/api/contacto", parametros).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    }
}